<template>
  <v-layout>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title>{{ getDialogTitle }}</v-card-title>
          <v-card-text class="pb-0">
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  v-model="extension.nombre"
                  label="Nombre"
                  placeholder="Cabina..."
                  :rules="nombreRules"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="pt-0">
                <v-text-field
                  v-model="extension.extension"
                  placeholder="9001"
                  label="Extension"
                  outlined
                  dense
                  :rules="extensionRules"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="d-fex justify-center pt-0">
                <v-switch
                  v-model="extension.estado"
                  inset
                  class="pt-0 mt-2"
                  color="primary"
                  label="Estado Extension"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4 pt-0 pb-4">
            <v-btn color="primary" outlined @click="clear">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-flex class="px-10 py-5">
      <v-data-table
        :headers="headers"
        :items="extensiones"
        :search="search"
        :loading="loader"
        loading-text="Listando Datos..."
        class="elevation-1"
      >
        <template v-slot:top>
          <v-container class="px-5 py-4">
            <v-layout>
              <h2 class="py-2 pl-3">Listado de Extensiones</h2>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row class="mt-6 mb-4">
              <v-flex xs12 sm12 md6 class="px-2">
                <v-text-field
                  class="text-xs-center"
                  v-model="search"
                  append-icon="search"
                  label="Búsqueda"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex
                xs12
                sm12
                md2
                class="text-center pt-3 mr-2"
                align-self-center
              >
                <v-btn color="blue" dark block @click="dialog = true">
                  Agregar Extensión
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="item.estado ? 'green' : 'red'" dark>
            {{ item.estado ? "Activo" : "Inactivo" }}
          </v-chip>
        </template>

        <template v-slot:[`item.editar`]="{ item }">
          <v-btn icon @click="detalles(item)">
            <v-icon>tab</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    valid: true,
    extension: {
      extensionId: null,
      extension: "",
      nombre: "",
      estado: false,
    },
    nombreRules: [
      (v) => !!v || "El nombre es requerido",
      (v) => (v && v.length <= 50) || "Nombre debe ser menor a 50 caracteres",
    ],
    extensionRules: [
      (v) => !!v || "La extensión es requerida",
      (v) => /^[0-9]+$/.test(v) || "Solo se permiten números",
      (v) => (v && v.length <= 4) || "Menor o igual a 4 caracteres",
    ],
    loader: false,
    editing: false,
    search: "",
    headers: [
      { text: "ID", value: "extensionId", align: "center", width: 100 },
      { text: "Nombre Extensión", value: "nombre", align: "center" },
      { text: "Número Extensión", value: "extension", align: "center" },
      { text: "Estado Extensión", value: "estado", align: "center" },
      { text: "Editar", value: "editar", align: "center", width: 100 },
    ],
    extensiones: [],
    dialog: false,
    id_cartera: 0,
    cartera_nombre: "",
    expediente: "",
    flag: 1,
  }),
  created() {
    this.listar();
  },
  computed: {
    getDialogTitle() {
      return this.extension.extensionId == null
        ? "Nueva Extensión"
        : "Editar Extensión";
    },
  },
  methods: {
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Extensiones", configuracion)
        .then((res) => (this.extensiones = res.data))
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    guardar() {
      if (this.$refs.form.validate()) {
        if (this.extension.extensionId == null) {
          this.nuevaExtension();
        } else {
          this.editarExtension();
        }
      }
    },
    nuevaExtension() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/Extensiones",
          {
            nombre: this.extension.nombre,
            extension: this.extension.extension,
            estado: this.extension.estado,
          },
          configuracion
        )
        .then((res) => {
          console.log("Nueva");
          this.listar();
          this.clear();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    editarExtension() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/Extensiones/${this.extension.extensionId}`,
          {
            Nombre: this.extension.nombre,
            Extension: this.extension.extension,
            Estado: this.extension.estado,
          },
          configuracion
        )
        .then(() => {
          this.listar();
          this.clear();
        })
        .catch((err) => console.error(err));
    },
    detalles(item) {
      this.dialog = true;
      this.extension = { ...item };
    },
    clear() {
      this.dialog = false;
      this.$refs.form.resetValidation();
      this.extension = {
        extensionId: null,
        extension: "",
        nombre: "",
        estado: false,
      };
    },
  },
};
</script>